import {animate, group, keyframes, state, style, transition, trigger} from "@angular/animations";

export function fadeInOut(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state('loading', style({
      opacity: 0.1,
      // padding: '200px 0 0 0',
    })),
    state('loaded', style({
      opacity: 1,
      // padding: '0 0 0 0'
    })),
    transition(stateFrom + ' => ' + stateTo, [
      animate('.5s')
    ]),
    transition(stateTo + ' => ' + stateFrom, [
      animate('0.1s')
    ]),
  ])
}

export function slideUpDown(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state(stateFrom, style({transform: 'translateY(100%)'})),
    state(stateTo, style({transform: 'translateY(0)'})),
    transition(stateFrom + ' => ' + stateTo, [
      animate('.5s'),
    ]),
    transition(stateTo + ' => ' + stateFrom, [
      animate('.1s'),
    ]),
  ]);
}

export function fadeInOutSlideUpDown(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state(stateFrom, style({opacity: .1, transform: 'translateY(100%)'})),
    state(stateTo, style({opacity: 1, transform: 'translateY(0)'})),
    transition(`${stateFrom} => ${stateTo}`, group([
      animate('.5s', style({opacity: 1})),
      animate('.2s', style({transform: 'translateY(0)'})),
    ])),
    transition(`${stateTo} => ${stateFrom}`, group([
      animate('.2s', style({opacity: .5})),
      animate('.5s', style({transform: 'translateY(100%)'})),
    ])),
  ]);
}
export function fadeInOutScaleIn(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state(stateFrom, style({opacity: .1, transform: 'scale(0)'})),
    state(stateTo, style({opacity: 1, transform: 'scale(1)'})),
    transition(`${stateFrom} => ${stateTo}`, group([
      animate('.5s', style({opacity: 1})),
      animate('.2s', style({transform: 'scale(1)'})),
    ])),
    transition(`${stateTo} => ${stateFrom}`, group([
      animate('.2s', style({opacity: .5})),
      animate('.5s', style({transform: 'scale(0)'})),
    ])),
  ]);
}


export function scale(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state(stateFrom, style({transform: 'scale(0)'})),
    state(stateTo, style({transform: 'scale(1)'})),
    transition(stateFrom + ' => ' + stateTo, [
      animate('.3s'),
    ]),
    transition(stateTo + ' => ' + stateFrom, [
      animate('.3s'),
    ]),
  ]);
}

export function rotate(
  animationTrigger: string,
  stateFrom: string,
  stateTo: string,
) {
  return trigger(animationTrigger, [
    state(stateFrom, style({transform: 'rotate(300deg)'})),
    state(stateTo, style({transform: 'rotate(360deg)'})),
    transition(stateFrom + ' => ' + stateTo, [
      animate('.3s'),
    ]),
    transition(stateTo + ' => ' + stateFrom, [
      animate('.3s'),
    ]),
  ]);
}


/*
* animation for layout change
 */
export function slideIn(animationTrigger: string, direction: 'left' | 'right') {
  let from = direction == 'left' ? '-100%' : '100%'
  return trigger(animationTrigger, [
    state('void', style({
      transform: `translateX(${from})`
    })),
    transition(':enter', [
      animate('300ms', style({transform: 'translateX(0)'})),
    ]),
  ]);
}
export function slideInBlurry(animationTrigger: string, direction: 'left' | 'right') {
  let from = direction == 'left' ? '-100%' : '100%'
  return trigger(animationTrigger, [
    transition(':enter', [
      style({ transform: `translateX(${from})`, opacity: 0, filter: 'blur(20px)' }),
      animate('0.5s ease-out', style({ transform: 'translateY(0)', opacity: 1, filter: 'blur(0px)' }))
    ]),
  ])
}

/*
* scale animation for upsert component
 */
export function scaleIn(animationTrigger: string) {
  return trigger(animationTrigger, [
    state('void', style({transform: 'scale(0)'})),
    transition(':enter', [
      animate('300ms', style({transform: 'scale(1)'})),
    ]),
  ]);
}

export function flipInX(animationTrigger: string) {
  return trigger(animationTrigger, [
    transition(':enter', [
      style({ transform: 'perspective(1000px) rotateX(-90deg)' }),
      animate('400ms', style({ transform: 'perspective(1000px) rotateX(0deg)' })),
    ]),
  ]);
}

export function wobble(animationTrigger: string) {
  return trigger(animationTrigger, [
    transition(':enter', [
      animate('400ms ease-in-out', keyframes([
        style({ transform: 'translateX(-5%)', offset: 0 }),
        style({ transform: 'translateX(5%)', offset: 0.5 }),
        style({ transform: 'translateX(0)', offset: 1 }),
      ])),
    ]),
  ]);
}

export function jello(animationTrigger: string) {
  return trigger(animationTrigger, [
    transition(':enter', [
      animate('300ms ease-in-out', keyframes([
        style({ transform: 'skewX(-12deg) skewY(-12deg)', offset: 0 }),
        style({ transform: 'skewX(6deg) skewY(6deg)', offset: 0.5 }),
        style({ transform: 'skewX(0deg) skewY(0deg)', offset: 1 }),
      ])),
    ]),
  ]);
}

export function hingeInFromTop(animationTrigger: string) {
  return trigger(animationTrigger, [
    transition(':enter', [
      style({ transformOrigin: 'top', transform: 'rotateX(-90deg)' }),
      animate('400ms', style({ transform: 'rotateX(0deg)' })),
    ]),
  ]);
}

export function bounceIn(animationTrigger: string) {
  return trigger(animationTrigger, [
    transition(':enter', [
      animate('400ms', keyframes([
        style({ transform: 'scale(0)', offset: 0 }),
        style({ transform: 'scale(1.2)', offset: 0.5 }),
        style({ transform: 'scale(1)', offset: 1 }),
      ])),
    ]),
  ]);
}









